'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
interface UseAnchorScrollArgs {
  /** Bumped by the parent each time the floating rank bar requests a jump. */
  pulseTick: number | undefined;
  /** The user whose row we jump to (the viewer). `undefined` ⇒ no jump target. */
  anchorUserId: string | undefined;
  /** True once the anchor row is present in the loaded (top-down) entries. */
  isAnchorLoaded: boolean;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => void;
}

/**
 * Drives the floating-rank-bar "jump to my row" WITHOUT the backend's windowed
 * anchor fetch (which page-aligns to the anchor's offset and strands the list in
 * a bottom window with no way to scroll up — the SDK list paginates forward
 * only). On each jump request this pages the list forward FROM THE TOP until the
 * anchor row loads, then emits a `scrollTick` the DataTable's scroll-into-view
 * effect consumes. The board stays rooted at rank 1, so the user can scroll
 * freely up and down after landing.
 */
export function useAnchorScroll(t0) {
  const $ = _c(8);
  const {
    pulseTick,
    anchorUserId,
    isAnchorLoaded,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage
  } = t0;
  let t1;
  let t2;
  if ($[0] !== anchorUserId || $[1] !== fetchNextPage || $[2] !== hasNextPage || $[3] !== isAnchorLoaded || $[4] !== isFetchingNextPage || $[5] !== pulseTick) {
    t1 = () => {
      if (pulseTick === undefined || anchorUserId === undefined || isAnchorLoaded || !hasNextPage || isFetchingNextPage) {
        return;
      }
      fetchNextPage();
    };
    t2 = [anchorUserId, fetchNextPage, hasNextPage, isAnchorLoaded, isFetchingNextPage, pulseTick];
    $[0] = anchorUserId;
    $[1] = fetchNextPage;
    $[2] = hasNextPage;
    $[3] = isAnchorLoaded;
    $[4] = isFetchingNextPage;
    $[5] = pulseTick;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useEffect(t1, t2);
  return pulseTick !== undefined && anchorUserId !== undefined && isAnchorLoaded ? pulseTick : undefined;
}